import { responseEnum } from "./enum";

export default function ErrorHandler(data, setSnackBar) {
  const payload = data?.payload;
  if (!payload) {
    setSnackBar("error", "Unable to reach the server.");
    return false;
  }
  const apiData = payload?.data;
  const code = apiData?.code ?? apiData?.data?.code;
  const message =
    apiData?.message ||
    payload?.message ||
    apiData?.data?.message ||
    payload?.statusText;

  if (code === responseEnum.FailureCode) {
    if (message) setSnackBar("error", message);
    return false;
  }
  if (payload?.status === responseEnum.ForbiddenCode) {
    setSnackBar("error", message || "You don't have permission to do that.");
    return false;
  }
  if (payload?.status === responseEnum.InternalServerCode) {
    setSnackBar("error", message || payload?.statusText || "Internal server error.");
    return false;
  }
  if (payload?.status === responseEnum.ValidationCode) {
    const errors = apiData?.errors || apiData?.data?.errors;
    if (errors) {
      let valuesArray = Object.values(errors);
      if (valuesArray && valuesArray.length > 0) {
        setSnackBar("error", valuesArray[0]);
        return false;
      }
    }
    if (message || payload?.title) {
      setSnackBar("error", message || payload?.title);
    }
    return false;
  }
  if (payload?.status >= 500) {
    setSnackBar("error", "Unable to reach the server.");
    return false;
  }
  return true;
}
